"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingScreen = exports.ConfirmationModal = exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Modal = ({ show, close, children }) => {
    if (!show)
        return null;
    return (0, jsx_runtime_1.jsx)("div", { className: "modal", children: (0, jsx_runtime_1.jsxs)("div", { className: "message", children: [(0, jsx_runtime_1.jsx)("button", { className: "cancel-button", onClick: close, "aria-label": "cancel", children: "X" }), (0, jsx_runtime_1.jsx)("div", { className: "modal-body", children: children })] }) });
};
exports.Modal = Modal;
const ConfirmationModal = ({ show, confirm, cancel, children }) => {
    if (!show)
        return null;
    return (0, jsx_runtime_1.jsxs)(exports.Modal, { show: show, close: cancel, children: [(0, jsx_runtime_1.jsx)("h1", { children: children }), (0, jsx_runtime_1.jsx)("div", { className: "modal-controls", children: (0, jsx_runtime_1.jsx)("button", { onClick: confirm, "aria-label": "confirm", children: "\u2705" }) })] });
};
exports.ConfirmationModal = ConfirmationModal;
const LoadingScreen = ({ children }) => {
    return (0, jsx_runtime_1.jsx)("h1", { children: children || "Connecting..." });
};
exports.LoadingScreen = LoadingScreen;
